<template>
  <v-app>
    <v-main>
      <section class="header">
        <img src="/img/logo.svg" width="120" alt="ASSA Abloy">

        <!-- <v-text-field
          class="search"
          placeholder="Search documentation"
          outlined
          hide-details
          background-color="#eeeeee"
          dense
          prepend-inner-icon="mdi-magnify"
        ></v-text-field> -->

        <div class="sign-out-box">
          <v-btn
            text
            @click.prevent="logout()">
            Sign out
          </v-btn>
        </div>
      </section>

      <section class="sub-header">
        <div>
          <router-link
            :to="{name:'Overview'}"
            class="grey--text text--darken-2 header-link"
          >Documentation</router-link>
        </div>

        <div>
          <router-link
            v-if="shouldShowManage"
            :to="getRouteForManageLink()"
            class="grey--text text--darken-2 header-link mr-8"
          >Manage</router-link>

          <router-link
            :to="{name: 'Account'}"
            class="grey--text text--darken-2 header-link"
          >Account</router-link>
        </div>
      </section>

      <div class="footer" style="display: none">
        <p>v{{ $store.state.buildVersion }}</p>
      </div>

      <v-divider class="mb-0"></v-divider>

      <slot />
    </v-main>
  </v-app>
</template>

<script>
import constants from 'august-constants';

import config from '../config';
import util from '../util';

export default {
  data: () => {
    return {
      constants,
    };
  },
  computed: {
    shouldShowManage: function () {
      return this.$store.state.role !== constants.DeveloperRoles.PARTNER_READER;
    },
  },
  methods: {
    logout: async function () {
      const options = {
        method: 'POST',
        ...config.defaultFetchOptions,
      };
      const result = await util.fetch(`${this.$store.state.apiHost}/logout`, options);

      if (result.ok) {
        util.deleteLocalStorage(this.$store);
        this.$store.commit('snackbar', {text: 'Logged out', color: 'success'});
        this.$router.push(({name: 'Index'}));
      } else {
        this.$store.commit('snackbar', {text: 'Failed to logout.', color: 'error'});
      }
    },
    getRouteForManageLink: function () {
      if (this.$store.state.role === constants.DeveloperRoles.PARTNER_ADMIN) {
        return { name: 'Users' };
      } else if (this.$store.state.role === constants.DeveloperRoles.GLOBAL_ADMIN) {
        return { name: 'Partners' };
      }
    },
  },
};
</script>

<style lang="scss">
.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 2rem 4rem 1rem 4rem;

  .logo {
    margin-right: 1rem;
  }

  .header-link {
    font-size: 1.125rem;
  }

  .search {
    flex-grow: 0;
    width: 236px;
    transition: width 0.25s ease-in-out;

    &.v-input--is-focused {
      width: 100%;
    }

    .v-input__prepend-inner {
      margin-right: 4px;
    }
  }

  .sign-out-box {
    flex-grow: 1;
    text-align: right;
  }
}

.sub-header {
  display: flex;
  justify-content: space-between;
  align-items: end;
  padding: 1rem 4rem;
}

.content {
  padding: 2rem 4rem 1rem 4rem;
}

.footer {
  position: fixed;
  left: 25px;
  bottom: 0;
  text-align: left;
  color: grey;
  font-size: 14px;
}

.header,
.sub-header,
.content {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
